(() => {
  const phone = window.matchMedia('(max-width: 767px)');
  const selector = '.wt-product__option__body--swatches .f-swatch__list';

  const reveal = (row, item) => {
    if (!item) return;
    const rowBox = row.getBoundingClientRect();
    const itemBox = item.getBoundingClientRect();
    // 44 px clears the 32 px arrow on each side, so the picked circle never sits under one.
    if (itemBox.left < rowBox.left + 44 || itemBox.right > rowBox.right - 44) {
      row.scrollLeft += itemBox.left - rowBox.left - 44;
    }
  };

  // The photo is fitted whole inside a wider box, so the "1 / 2" counter sat on the white margin.
  // Pin it 8 px inside the photo's own bottom-left corner, like the Sold out label (Rami, 2026-10-26).
  const placeCounter = (gallery) => {
    const counter = gallery && gallery.querySelector('.swiper-pagination-fraction');
    const img = gallery && (gallery.querySelector('.swiper-slide-active img') || gallery.querySelector('img'));
    if (!counter || !img || !img.naturalWidth || !counter.getClientRects().length) return;
    // A swipe slides the photo sideways and changes the counter text as it starts, so measure the photo
    // inside its own slide and add the slider box, which stays still (Rami, 2026-10-26).
    const slide = img.closest('.swiper-slide') || img;
    const box = (counter.offsetParent || gallery).getBoundingClientRect();
    const i = img.getBoundingClientRect();
    const s = slide.getBoundingClientRect();
    const r = { left: box.left + i.left - s.left, top: i.top, width: i.width, height: i.height };
    const c = counter.getBoundingClientRect();
    const cs = getComputedStyle(counter);
    const w = Math.min(r.width, r.height * img.naturalWidth / img.naturalHeight);
    const h = Math.min(r.height, r.width * img.naturalHeight / img.naturalWidth);
    // Shift from where the counter sits now, so its margins and offset parent don't matter. Writes only on change.
    const left = `${Math.round(parseFloat(cs.left) + r.left + (r.width - w) / 2 + 8 - c.left)}px`;
    const bottom = `${Math.round(parseFloat(cs.bottom) + c.bottom - (r.top + (r.height + h) / 2 - 8))}px`;
    if (counter.style.getPropertyValue('left') !== left) counter.style.setProperty('left', left, 'important');
    if (counter.style.getPropertyValue('bottom') !== bottom) counter.style.setProperty('bottom', bottom, 'important');
  };

  const watchCounter = () => {
    if (!phone.matches) return;
    const gallery = document.querySelector('.wt-product__gallery');
    const counter = gallery && gallery.querySelector('.swiper-pagination-fraction');
    if (!counter) return;
    const place = () => requestAnimationFrame(() => placeCounter(gallery));
    // Photo size changes on resize, on image load and on a swipe to a photo of another shape.
    new MutationObserver(place).observe(counter, { childList: true, subtree: true, characterData: true });
    gallery.addEventListener('load', place, true);
    // The slider's height eases to the new photo's after a swipe, which moves the photo's foot.
    gallery.addEventListener('transitionend', place);
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    [300, 1000, 2500].forEach((delay) => setTimeout(place, delay));
    place();
  };

  // Colour rows open on the picked colour (the first colour when nothing else is picked); arrows show there are more either side,
  // and "See all" opens every colour at once (Mo, 2026-10-26).
  const addRowControls = (row, wrap, toggle) => {
    const total = row.children.length;
    wrap.classList.add('vc-row');
    const arrows = ['prev', 'next'].map((side) => {
      const arrow = document.createElement('button');
      arrow.type = 'button';
      arrow.className = `vc-row__arrow vc-row__arrow--${side}`;
      arrow.setAttribute('aria-label', side === 'prev' ? 'Earlier colours' : 'More colours');
      arrow.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="${side === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}" fill="none" stroke="currentColor" stroke-width="2"/></svg>`;
      arrow.addEventListener('click', () => row.scrollBy({ left: (side === 'prev' ? -0.8 : 0.8) * row.clientWidth, behavior: 'smooth' }));
      wrap.appendChild(arrow);
      return arrow;
    });
    toggle.classList.add('vc-row-toggle');
    toggle.setAttribute('aria-expanded', 'false');
    const update = () => {
      const open = wrap.classList.contains('is-open');
      const start = row.scrollLeft > 4;
      const end = row.scrollLeft + row.clientWidth < row.scrollWidth - 4;
      // Writes only on change: this runs on every scroll, and page-row writes wake the product's observers.
      const focused = arrows.indexOf(document.activeElement);
      [open || !start, open || !end].forEach((hide, i) => {
        if (arrows[i].hidden !== hide) arrows[i].hidden = hide;
      });
      if (wrap.classList.contains('is-scrolled') !== (start && !open)) wrap.classList.toggle('is-scrolled', start && !open);
      if (wrap.classList.contains('is-end') !== (!end && !open)) wrap.classList.toggle('is-end', !end && !open);
      const hideToggle = !open && !start && !end;
      if (toggle.hidden !== hideToggle) toggle.hidden = hideToggle;
      const label = open ? 'Show less' : `See all ${total}`;
      if (toggle.textContent !== label) toggle.textContent = label;
      // An arrow that hides while focused hands focus to the other arrow, or else to "See all".
      if (focused > -1 && arrows[focused].hidden) (!arrows[1 - focused].hidden ? arrows[1 - focused] : toggle).focus();
    };
    const setOpen = (open) => {
      wrap.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      update();
    };
    // The open list stays open while the shopper compares colours (Rami, 2026-10-26).
    let picked = null;
    row.addEventListener('click', (event) => {
      picked = [...row.children].find((child) => child.contains(event.target)) || picked;
    });
    // "Show less" closes the list and keeps the picked colour in view.
    toggle.addEventListener('click', () => {
      const open = !wrap.classList.contains('is-open');
      setOpen(open);
      const item = [...row.children].find((child) => child.classList.contains('is-selected') || child.querySelector('input:checked')) || picked;
      if (!open && item) reveal(row, item);
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    // A shopper who came from a colour's link sees that colour, not the start of the row (Mo, 2026-10-26).
    row.scrollLeft = 0;
    reveal(row, [...row.children].find((child) => child.classList.contains('is-selected') || child.querySelector('input:checked')));
    update();
    return update;
  };

  const watchPageRow = () => {
    if (!phone.matches) return;
    const row = document.querySelector(`.wt-product__info ${selector}`);
    const wrap = row && row.closest('.swiper-container');
    const title = row && row.closest('.wt-product__option')?.querySelector('.wt-product__option__wrapper');
    if (!wrap || !title) return;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    title.classList.add('vc-row-title');
    title.appendChild(toggle);
    addRowControls(row, wrap, toggle);
  };

  const watchRow = () => {
    const list = document.querySelector(selector);
    if (!list) return;
    let queued = false;
    const update = () => {
      queued = false;
      const box = list.getBoundingClientRect();
      const onScreen = phone.matches && box.bottom > 0 && box.top < window.innerHeight;
      document.querySelectorAll('.wt-product__sticky-buy--mobile').forEach((bar) => bar.classList.toggle('vc-pcp-hidden', onScreen));
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    [300, 1000, 2500].forEach((delay) => setTimeout(queue, delay));
    update();
  };

  // Phones: a panel pinned to the bottom holds name, price, every colour and Add to cart, like Zara (Test: Zara-style buy panel 2026-10-26).
  const watchBuyPanel = () => {
    const product = document.querySelector('.wt-product.vc-pcp');
    const atc = product && product.querySelector('.main-product__buy-buttons--container .js-add-to-cart');
    const option = product && product.querySelector('.wt-product__option:has(.wt-product__option__body--swatches)');
    if (!atc || !option) return;
    // Colours are either options of this product (inputs) or links to each colour's own product page.
    const here = location.pathname.replace(/\/$/, '');
    const inputChoices = [...option.querySelectorAll('.f-swatch__list__item input')].map((input) => ({
      value: input.value,
      li: input.closest('li'),
      isChecked: () => input.checked,
      soldOut: () => input.classList.contains('disabled'),
      pick: () => input.click(),
    }));
    const linkChoices = [...option.querySelectorAll('.f-swatch__list__item a[href]')].map((link) => ({
      value: (link.getAttribute('title') || link.getAttribute('aria-label') || '').replace(/^Colou?r:\s*/i, '').trim(),
      li: link.closest('li'),
      isChecked: () => new URL(link.href, location.href).pathname.replace(/\/$/, '') === here,
      soldOut: () => link.classList.contains('is-sold-out'),
      pick: () => { window.location.href = link.href; },
    }));
    const inputs = inputChoices.length ? inputChoices : linkChoices;
    if (!inputs.length) return;
    const title = product.querySelector('.wt-product__name');
    const priceWrap = product.querySelector('.wt-product__price');

    const panel = document.createElement('div');
    panel.className = 'vc-buy-panel';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Choose a colour and add to cart');
    panel.innerHTML = '<div class="vc-buy-panel__head"><span class="vc-buy-panel__name"></span><span class="vc-buy-panel__price"></span></div><div class="vc-buy-panel__colour"><button type="button" class="vc-buy-panel__picked"></button><button type="button" class="vc-buy-panel__count"></button><span class="vc-buy-panel__slim-price"></span></div><div class="vc-buy-panel__row"><div class="vc-buy-panel__dots"></div></div><div class="vc-buy-panel__more"></div><div class="vc-buy-panel__offer"></div><button type="button" class="vc-buy-panel__atc wt-button wt-button--primary"></button>';
    document.body.append(panel);
    document.body.classList.add('vc-fit-bar-mounted', 'vc-buy-panel-mounted');

    const priceBox = panel.querySelector('.vc-buy-panel__price');
    const slimPrice = panel.querySelector('.vc-buy-panel__slim-price');
    const offerBox = panel.querySelector('.vc-buy-panel__offer');
    const picked = panel.querySelector('.vc-buy-panel__picked');
    const dots = panel.querySelector('.vc-buy-panel__dots');
    const panelAtc = panel.querySelector('.vc-buy-panel__atc');
    const soldOutNotify = () => {
      const form = atc.closest('form');
      return form && form.classList.contains('vc-oos-one') ? form.querySelector('.restock-rocket-button-container') : null;
    };
    panel.querySelector('.vc-buy-panel__name').textContent = title ? title.textContent.trim() : '';
    inputs.forEach((input) => {
      const swatch = input.li.querySelector('.f-swatch__list__link__content');
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vc-buy-panel__dot';
      dot.setAttribute('aria-label', input.value);
      dot.dataset.value = input.value;
      if (swatch) dot.style.cssText = swatch.getAttribute('style') || '';
      dot.addEventListener('click', () => input.pick());
      dots.appendChild(dot);
    });
    const updateDots = addRowControls(dots, panel.querySelector('.vc-buy-panel__row'), panel.querySelector('.vc-buy-panel__count'));
    // Show less re-measures the closed panel, since a pick while open can change its height.
    panel.querySelector('.vc-buy-panel__count').addEventListener('click', () => requestAnimationFrame(() => fit()));

    // Photo fills the space between the header and the panel, whole and uncropped.
    const gallery = product.querySelector('.wt-product__gallery');
    // The stylesheet reserves the full panel's room from the first paint, so the photo keeps its height while the offer line loads.
    const reserve = parseFloat(getComputedStyle(product).getPropertyValue('--vc-buy-panel')) || 0;
    const fit = () => {
      if (!phone.matches || !gallery) return;
      // Writes only on change: show() calls this on every scroll.
      const header = `${Math.round(gallery.getBoundingClientRect().top + window.scrollY)}px`;
      if (product.style.getPropertyValue('--vc-pcp-header') !== header) product.style.setProperty('--vc-pcp-header', header);
      // Measure the full, closed panel only: phones fire resize while scrolling, and the slim bar's height grew the photo.
      // The open See all list covers the photo's foot instead of shrinking it.
      if (panel.classList.contains('is-shown') && !panel.classList.contains('is-slim') && !panel.querySelector('.vc-buy-panel__row.is-open') && panel.offsetHeight) {
        const height = `${Math.max(panel.offsetHeight, reserve)}px`;
        if (product.style.getPropertyValue('--vc-buy-panel') !== height) product.style.setProperty('--vc-buy-panel', height);
      }
      // The panel height sets the photo's height, which moves the photo's corner.
      placeCounter(gallery);
    };

    const priceText = () => {
      const price = product.querySelector('.wt-product__price .price');
      if (!price) return '';
      const onSale = price.querySelector('.price__sale.visible');
      const final = (onSale ? onSale.querySelector('.price-item--sale') : price.querySelector('.price__regular .price-item--regular'))?.textContent.trim() || '';
      const compare = onSale?.querySelector('.wt-product__price__compare')?.textContent.trim() || '';
      const percent = onSale?.querySelector('.price-item--percent')?.textContent.trim() || '';
      const badge = percent ? ` <span class="vc-buy-panel__off">${percent}</span>` : '';
      return compare && compare !== final ? `<s>${compare}</s> ${final}${badge}` : final;
    };

    // Other choices (such as Undercap Fabric) stay visible in the panel; a tap jumps to their picker on the page.
    const more = panel.querySelector('.vc-buy-panel__more');
    const others = [...product.querySelectorAll('.wt-product__option')].filter((o) => o !== option);
    const otherButtons = others.map((o) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vc-buy-panel__other';
      button.addEventListener('click', () => o.scrollIntoView({ block: 'center', behavior: 'smooth' }));
      more.appendChild(button);
      return [o, button];
    });
    more.hidden = otherButtons.length === 0;

    // Quantity deal first; once it's maxed (or a product has none), the whole cart's free-shipping gap from the theme's own bar settings.
    const ship = window.vcFreeShip;
    let cartTotal = null;
    // Price of the picked variant, so the line can say when this item alone reaches free shipping.
    let itemPrice = null;
    let variants = null;
    const variantInput = product.querySelector('.main-product__buy-buttons--container [name="id"], form[action*="/cart/add"] [name="id"]');
    const readItemPrice = () => {
      const id = variantInput && Number(variantInput.value);
      const v = variants && variants.find((x) => x.id === id);
      itemPrice = v ? v.price : null;
    };
    fetch(`${location.pathname.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((data) => { variants = data.variants || []; readItemPrice(); show(); })
      .catch(() => {});
    const money = (cents) => {
      const fmt = (ship && ship.format) || '${{amount}}';
      const value = cents / 100;
      const noDecimals = /amount_no_decimals/.test(fmt);
      const n = value.toLocaleString('en-US', { minimumFractionDigits: noDecimals ? 0 : 2, maximumFractionDigits: noDecimals ? 0 : 2 });
      return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, n);
    };
    const offerLine = (tierText) => {
      const maxed = !tierText || /maximum|max/i.test(tierText);
      if (!maxed || !ship || cartTotal === null) return tierText;
      const left = ship.at - cartTotal;
      if (left <= 0) return tierText || ship.done || '';
      if (itemPrice !== null && !atc.disabled && itemPrice >= left) return 'Add one more item to unlock free shipping';
      return `You're ${money(left)} away from free shipping`;
    };
    const refreshCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { cartTotal = c.total_price; show(); })
      .catch(() => {});

    // Null so the first show() scrolls the panel row to the colour picked on load.
    let lastChecked = null;
    let fullHeight = 0;
    const show = () => {
      const checked = inputs.find((input) => input.isChecked());
      const swatchStyle = checked ? (checked.li.querySelector('.f-swatch__list__link__content')?.getAttribute('style') || '') : '';
      const pickedHtml = `<span class="vc-buy-panel__mini" style="${swatchStyle.replace(/"/g, '&quot;')}"></span><span>${checked ? `Colour: ${checked.value}` : 'Pick a colour'}</span>`;
      if (picked.innerHTML !== pickedHtml) picked.innerHTML = pickedHtml;
      otherButtons.forEach(([o, button]) => {
        const text = `${(o.querySelector('.wt-product__option__title, legend, label')?.textContent || '').replace(/\s+/g, ' ').trim()} \u25BE`;
        if (button.textContent !== text) button.textContent = text;
      });
      const offer = document.getElementById('vc-vol-msg');
      const offerText = offerLine(offer ? offer.textContent.trim() : '');
      if (offerBox.textContent !== offerText) offerBox.textContent = offerText;
      offerBox.hidden = !offerText;
      const priceHtml = priceText();
      if (priceBox.innerHTML !== priceHtml) {
        priceBox.innerHTML = priceHtml;
        slimPrice.innerHTML = priceHtml;
      }
      // Sold-out pick: vc-soldout-notify.js hides Add to cart and relabels Restock Rocket's button, so copy that instead.
      const notifyBox = soldOutNotify();
      const notify = notifyBox && notifyBox.querySelector('.restock-rocket-button');
      if (notify) {
        if (panelAtc.dataset.vcOos !== notify.dataset.vcOos) {
          panelAtc.innerHTML = notify.innerHTML;
          panelAtc.dataset.vcOos = notify.dataset.vcOos || '';
        }
        panelAtc.classList.add('vc-oos-btn');
        panelAtc.disabled = false;
      } else {
        delete panelAtc.dataset.vcOos;
        panelAtc.classList.remove('vc-oos-btn');
        panelAtc.textContent = atc.textContent.trim() || 'Add to cart';
        panelAtc.disabled = atc.disabled;
      }
      dots.querySelectorAll('.vc-buy-panel__dot').forEach((dot) => {
        const input = inputs.find((i) => i.value === dot.dataset.value);
        dot.classList.toggle('is-selected', input === checked);
        dot.setAttribute('aria-pressed', input === checked ? 'true' : 'false');
        dot.classList.toggle('is-sold-out', !!input && input.soldOut());
      });
      const box = (notifyBox || atc).getBoundingClientRect();
      const fullyShown = box.height > 0 && box.top >= 0 && box.bottom <= window.innerHeight;
      const on = phone.matches && !fullyShown;
      // Colours in the panel only while the photo is in view and the page's own colours sit behind the panel.
      if (!panel.classList.contains('is-slim')) fullHeight = panel.offsetHeight;
      const photo = gallery ? gallery.getBoundingClientRect() : null;
      const photoInView = !!photo && photo.bottom > 200;
      const row = option.getBoundingClientRect();
      // The panel can first show before its offer line and Notify me button arrive, so judge against the reserved full height too.
      const rowInView = row.bottom > 0 && row.top < window.innerHeight - Math.max(fullHeight, reserve);
      panel.classList.toggle('is-slim', !photoInView || rowInView);
      panel.classList.toggle('is-shown', on);
      document.body.classList.toggle('vc-buy-panel-on', on);
      // After the slim toggle, so a pick made in the page's own row (panel slim, row hidden) is revealed by the same call that shows the row (OI-8, 2026-10-29).
      if (checked !== lastChecked && dots.clientWidth) {
        lastChecked = checked;
        reveal(dots, checked && dots.querySelector(`[data-value="${CSS.escape(checked.value)}"]`));
      }
      // After the slim toggle: the slim bar hides the row, which measured as "nothing to scroll" and hid See all and the arrows.
      updateDots();
      // The full panel grows on a sold-out pick (taller Notify button), so the photo follows it.
      fit();
    };

    picked.addEventListener('click', () => {
      if (panel.classList.contains('is-slim')) window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    panelAtc.addEventListener('click', () => {
      const notifyBox = soldOutNotify();
      if (notifyBox) {
        // A scripted click on the app's button doesn't open its form; its own openModal does (as in vc-notify.js).
        const rr = window._RestockRocket;
        const variant = atc.closest('form').querySelector('input[name="id"]');
        const handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
        if (rr && typeof rr.openModal === 'function' && variant && handle) {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(`${root}products/${handle}.js`)
            .then((r) => r.json())
            .then((p) => rr.openModal(p, Number(variant.value)))
            .catch(() => notifyBox.scrollIntoView({ block: 'center', behavior: 'smooth' }));
        } else {
          notifyBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        return;
      }
      if (!atc.disabled) atc.click();
    });

    show();
    fit();
    window.addEventListener('scroll', show, { passive: true });
    window.addEventListener('resize', () => {
      fit();
      show();
    });
    window.addEventListener('load', show);
    [0, 300, 1000, 2500].forEach((delay) => setTimeout(show, delay));
    new MutationObserver(show).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceWrap) new MutationObserver(show).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    refreshCart();
    let cartOpen = document.body.className.includes('page-overlay-cart-on');
    new MutationObserver(() => {
      const open = document.body.className.includes('page-overlay-cart-on');
      if (open !== cartOpen) { cartOpen = open; refreshCart(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // vc-cro.js builds the bundle bar after this script starts, so watch the whole product area, one update per frame.
    let queued = false;
    const queueShow = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; show(); });
    };
    new MutationObserver(queueShow).observe(product, { childList: true, subtree: true, characterData: true });
    product.addEventListener('change', () => [50, 400, 1000].forEach((delay) => setTimeout(() => { readItemPrice(); show(); }, delay)));
  };

  const start = () => {
    watchPageRow();
    watchRow();
    watchBuyPanel();
    watchCounter();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
